export default {
    message: {
        tiers: {
            t1: {
                label: "Selvstændigt virkende",
                desc: "<p>Samlet adgang til alle virtuelle apps og web- og SaaS-apps, beskytter brugere, apps og data med kontekstuelle sikkerhedskontroller fra start til slut.</p><p>Tilbyder proxy og SSO med mindre VPN til web-, SaaS-, virtuelle og mobile apps samt beskyttelse mod ondsindet indhold, keyloggers og screen capture-malware.</p>"
            },
            t2: {
                label: "Workspace Premium",
                desc: "<p>Komplet arbejdsrumløsning til arbejdstagere, der har brug for et fuldt digitalt arbejdsrum med granulær sikkerhed, men kræver ikke virtuelle apps og desktops.</p><p>Inkluderer Workspace Standard-funktionalitet samt avancerede SaaS- og web-sikkerhedskontroller, samlet endpoint-administration og Content Collaboration Premium.</p>"
            },
            t3: {
                label: "Workspace Premium Plus",
                desc: "<p>Omfattende løsning for arbejdsrum inklusive mulighed for hybrid installation af Citrix Virtual Apps and Desktops.</p><p>Inkluderer Workspace Premium-funktionalitet samt muligheden for administration af cloud for Citrix Virtual Apps and Desktops.</p>"
            }
        }
    }
}